import React, { useEffect, useState } from 'react';
import { useUserToEditAtom } from '../../atoms/users/useUserToEditAtom';
import { getAllUsers, searchUsers } from '../../api/authenticateAPIs';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../../context/NotificationContext';
import { NotificationType } from '../../enums/NotificationType';

import '../../css/pages/all_users_list.css';

import useAuth from "../../hooks/useAuth";

const UserList = () => {
  
  const { auth } = useAuth();
  const { showNotification } = useNotification();

  const [isLoading, setIsLoading] = useState(false);
  const [, setUserToEdit] = useUserToEditAtom();
  const [t, ] = useTranslation('global');
  const [message, setMessage] = useState('');
  const [userList, setUserList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchString, setSearchString] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    if (auth.uri !== 1) {
      navigate('/Unauthorized');
      return;
    }
  }, [auth.uri, navigate]);

  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      setIsLoading(true);
      try {
        if (searchString) {
          const results = await searchUsers(searchString);
          if (results.length === 0) {
            showNotification({ message: t('noResults'), type: NotificationType.Error });
          }
          setUserList(results);
        } else {
          const initialUsers = await getAllUsers();
          setUserList(initialUsers);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setUserList([]);
      } finally {
        setIsLoading(false);
      }
    }, searchString ? 1000 : 0);

    return () => clearTimeout(delayDebounce);
  }, [searchString, showNotification, t]);

  const handleUserClick = (id) => {
    const userDetails = userList.find((user) => user.id === id);
    setUserToEdit(userDetails);
    navigate('/EditUser');
  };

  const handleAddUser = () => {
    navigate("/CreateUser");
  }

  const handleGoBack = () => {
    navigate('/');
  };

  const handleSearch = () => {
    setShowSearch((prevShowSearch) => !prevShowSearch);
  }

  const handleSearchChange = (e) => {
    setIsLoading(true);
    setSearchString(e.target.value);
  }

  return (
    <div className="all-users-list page-wrap">

      <div className="header-title">
        <h1>{t('userList')}</h1>

        <div className='user-buttons-container'>
          <button className="add-button" onClick={handleAddUser}>
              <span className="material-symbols-outlined">add</span>
          </button>
            <button type='button' className='search-button' onClick={handleSearch}>
              <span className="material-symbols-outlined">search</span>
            </button>
        </div>
      </div>

      {showSearch && (
      <div className={`user-searchbar ${showSearch ? 'show' : 'hide'}`}>
        <input 
          type="text" 
          name="name" 
          value={searchString} 
          onChange={handleSearchChange}
          placeholder={t('searchByUsername')}
          autoFocus
        />
        <button type='submit'>
          <span className="material-symbols-outlined">search</span>
        </button>
      </div>
      )}

      <div className={`user-detail-wrapper ${isLoading ? 'center-loader' : ''}`}>
      {isLoading ? (
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div> 
        ) : message ? (
          <p className="user-detail no-users-message">{message}</p>
        ) : (
          userList.map((user, key) => (
            <div key={key} className="user-detail" onClick={() => handleUserClick(user.id)}>
              <div className="user-icon">
                {user.userFirstname.charAt(0) + user.userLastname.charAt(0)}
              </div>
              <span className="user-name-label">{user.userFirstname + " " + user.userLastname}</span>
              <span className="user-email-label">{user.userEmail}</span>
            </div>
          ))
        )}
      </div>

    <button onClick={handleGoBack} className="return-button">{t('return')}</button>
    </div>
  );
};

export default UserList;
